window.addEventListener('DOMContentLoaded', () => {
  const drawer_cart = document.querySelector('cart-drawer#mini-cart');
  const drawer_help = document.querySelector('#drawer_help');
  const drawer_samples = document.querySelector('openable-element#free-samples-products');
  const drawer_predictive_search = document.querySelector('#search-drawer.predictive-search');
  const drawer_mobile_menu = document.querySelector('#mobile-menu-drawer');
  const drawers = [drawer_cart, drawer_help, drawer_samples, drawer_predictive_search, drawer_mobile_menu];
  
  
  if(drawers.length > 0){
    drawers.forEach((drawer) => {
      if(!drawer) return;
  
      let observer = new MutationObserver(function(mutations) { // ~~> drawer observer
        mutations.forEach(function(mutation) {
          if (mutation.type === "attributes") {
            const hideWidgets = (hide) => {
              const selectors = [
                '#smile-ui-container',
                '.cc-revoke',
                '#dummy-chat-button-iframe',
                '.needsclick.kl-teaser-VV9SWy',
                '.needsclick.kl-teaser-WxUzqp',
                '#shopify-chat',                    // кращий селектор для Shopify Inbox
                '#shopify-chat-inbox-online-store-chat',
                '#giftbox-root iframe',
                '.bacurr-choiceDesign'
              ];
  
              selectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => {
                  hide ? el.classList.add('widget-hidden') : el.classList.remove('widget-hidden');
                });
              });
            };
  
            const bodyObserver = new MutationObserver(() => {
              hideWidgets(drawer.hasAttribute('open'));
            });
    
            bodyObserver.observe(document.body, {
              childList: true,
              subtree: true
            });
    
            hideWidgets(drawer.hasAttribute('open'));
          }
        })
      })
  
      observer.observe(drawer, {
        attributes: true, // configure it to listen to attribute changes
        childList: true
      });
    })
  }
  
})
